import React from 'react';
import { useTheme } from '@mui/material/styles';
import { Box, Grid, Typography } from '@mui/material';
import { useStyles } from './style';
import ActionCTA from '../shared/sweepr-action-cta/ActionCTA';
import { getBannerImage } from './infoTile.util';
import InfoTileIcon from './InfoTileIcon';

/**
 * @name InfoTile - Banner component
 * @param {*} props - Strapi cms data
 * @returns {JSX.Element} - Returns InfoTile Element
 */
const InfoTile = props => {
  const theme = useTheme();
  const {
    infoTileMobile,
    infoTileDesktop,
    infoTileTablet,
    infoTileForegroundDesktop,
    infoTileForegroundMobile,
    infoTileForegroundTablet,
  } = getBannerImage(props);
  const style = useStyles(
    theme,
    infoTileMobile,
    infoTileDesktop,
    infoTileTablet,
    infoTileForegroundDesktop,
    infoTileForegroundMobile,
    infoTileForegroundTablet,
  );
  return (
    <Grid
      container
      sx={props.cmsData?.Info_Tile_Images?.length > 0 ? style.InfoContainer : style.InfoCenterAlign}
    >
      <Grid container maxWidth='lg' sx={style.InfoMain}>
        <Grid item xs={12} sm={6} md={7} sx={style.InfoDetails}>
          <Box
            sx={props.cmsData?.Info_Tile_Images?.length > 0 ? style.InfoBox : style.InfoBoxCenter}
          >
            {props.cmsData?.icon?.data && props.cmsData?.Info_Tile_Images?.length === 0 && (
              <InfoTileIcon icon={props?.cmsData?.icon} />
            )}
            <Box
              sx={
                props.cmsData?.Info_Tile_Images?.length > 0 ? style.infoText : style.infoTextAlign
              }
            >
              <Typography variant='h2' sx={style.InfoTitle}>
                {props?.cmsData?.title}
              </Typography>
              {/* TBU subtitle 3 is introduced in theme as apart of accesibility EDQ-6937 */}
              <Typography sx={style.InfoDescription}>{props?.cmsData?.description}</Typography>
            </Box>
            <Box sx={style.InfoCTA}>
              <ActionCTA cta={props?.cmsData?.Info_Tile_CTAs} handleAction={props.handleAction} />
            </Box>
          </Box>
        </Grid>
        {props.cmsData?.Info_Tile_Images?.length > 0 && (
          <Grid item xs={12} sm={6} md={3} sx={style.ForegroundImageContainer}>
            <Box sx={style.ForegroundImage} />
          </Grid>
        )}
      </Grid>
    </Grid>
  );
};
InfoTile.displayName = 'InfoTile';
export default InfoTile;
